<template>
    <div>
        <div class="content-header">
            <div class="container">
                <div class="row">
                    <div class="col-sm-7">
                        <h1 class="m-0 mr-3 float-left text-dark">Envio de bolsas externas</h1>
                    </div>
                    <div class="col-sm-5">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <router-link to="/">
                                    <font-awesome-icon icon="home"></font-awesome-icon>
                                </router-link>
                            </li>
                            <li class="breadcrumb-item">Envio</li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="card card-info">
                            <div class="card-header">
                                <h3 class="card-title">Informações</h3>
                            </div>
                            <div class="card-body">
                                <p>O arquivo em anexo deve ser do formato CSV e deve seguir o seguinte formato:</p>
                                <p>
                                    <code>cpf,nome,valor,vigencia_inicio,vigencia_fim</code>
                                </p>
                                <p><strong>Observações:</strong></p>
                                <p>
                                    <ul>
                                        <li>cpf: Somente números</li>
                                        <li>nome: Nome completo do bolsista</li>
                                        <li>valor: Número com ponto para separar os centavos. Ex. 1500.00</li>
                                        <li>vigencia_inicio: Data no formato dd/mm/aaaa</li>
                                        <li>vigencia_fim: Data no formato dd/mm/aaaa</li>
                                    </ul>
                                </p>
                            </div>
                        </div>
                        <div class="card card-default card-secondary">
                            <div class="card-header">
                                <h3 class="card-title">Selecione um arquivo</h3>
                            </div>
                            <div class="card-body p-0">
                                <div 
                                    v-if="success !== null"
                                    :class="{
                                        'msg': true, 
                                        'bg-success': success, 
                                        'bg-danger': success == false
                                    }">
                                    <template v-if="success">
                                        Arquivo enviado sucesso
                                    </template>
                                    <template v-else>
                                        Ocorreu um problema ao enviar o arquivo. {{this.mensagemErro}}
                                    </template>
                                </div>
                                <form @submit.prevent="upload" class="pt-3 pl-3 pr-3">
                                    <div class="row">
                                        <div class="col-3">
                                            <div class="form-group">
                                                <select class="form-control" v-model="form.fontePagadora" required>
                                                    <option :value="null">-- Fonte Pagadora --</option>
                                                    <template v-for="tipo in fontes_pagadoras">
                                                        <option :value="tipo.nome.trim()" :key="tipo.nome">{{tipo.nome}}</option>
                                                    </template>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-2">
                                            <div class="form-group">
                                                <select class="form-control" v-model="form.mes" required>
                                                    <option :value="null">-- Mês --</option>
                                                    <option value="01">Janeiro</option>
                                                    <option value="02">Fevereiro</option>
                                                    <option value="03">Março</option>
                                                    <option value="04">Abril</option>
                                                    <option value="05">Maio</option>
                                                    <option value="06">Junho</option>
                                                    <option value="07">Julho</option>
                                                    <option value="08">Agosto</option>
                                                    <option value="09">Setembro</option>
                                                    <option value="10">Outubro</option>
                                                    <option value="11">Novembro</option>
                                                    <option value="12">Dezembro</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-2">
                                            <select class="form-control" v-model="form.ano" required>
                                                <option :value="null">-- Ano --</option>
                                                <template v-for="index in 11">
                                                    <option :value="currentYear+1-index" :key="index">{{currentYear+1-index}}</option>
                                                </template>
                                            </select>
                                        </div>
                                        <div class="col-4">
                                            <div class="form-group">
                                                <div class="input-group">
                                                    <div class="custom-file">
                                                        <input 
                                                            id="id_file"
                                                            type="file" 
                                                            class="custom-file-input"
                                                            required
                                                            @change="processFile($event)">
                                                        <label for="id_file" class="custom-file-label">
                                                            <template v-if="!form.file">
                                                                Escolha um arquivo
                                                            </template>
                                                            <template v-else>
                                                                {{form.file.name}}
                                                            </template>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-1">
                                            <button type="submit" class="btn btn-primary">Enviar</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="overlay" v-if="loading">
                                <font-awesome-icon icon="sync" class="fa fa-spin" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api'

export default {
    name: 'Upload',
    data() {
        return {
            error: null,
            form:{
                file: null,
                fontePagadora: null,
                mes:null,
                ano:null,
            },
            loading: false,
            success: null,
            mensagemErro: "",
            fontes_pagadoras: null,
        }
    },
    computed:{
        currentYear: function () {
            return new Date().getFullYear()
        }
    },
    methods: {
        reset () {
            this.form = {
                file: null,
                fontePagadora: null,
                mes:null,
                ano:null,
            }
        },
        async upload () {
            this.loading = true;
            let formData = new FormData()
            formData.append('file', this.form.file)
            formData.append('fontePagadora', this.form.fontePagadora)
            formData.append('competenciaMes', this.form.mes)
            formData.append('competenciaAno', this.form.ano)
            const response = await api.post('bolsas/upload', formData)

            if (response.ok) {
                this.success = true
            } else {
                this.mensagemErro = response.data;
                this.success = false
            }
            this.loading = false
            this.reset()
        },
        async getFontePagadora (){
            const response = await api.get('fontes_pagadoras')

            if (response.ok) {
                this.fontes_pagadoras = response.data.content
            }
        },
        processFile (event) {
            this.form.file = event.target.files[0]
        }
    },
    mounted () {
        this.getFontePagadora()
    }
}
</script>

<style>
    .custom-file-label::after{
        content: "Procurar";
    }

    .msg{
        padding: 10px 18px;
    }
</style>